export const ICON_VALUE_TO_I18N_KEY: Record<string, string> = {
  BOOK: 'documentCollections:icon.book',
  FOLDER: 'documentCollections:icon.folder',
  FILE: 'documentCollections:icon.file',
  NOTE: 'documentCollections:icon.note',
  STAR: 'documentCollections:icon.star',
  HEART: 'documentCollections:icon.heart',
  TAG: 'documentCollections:icon.tag',
  PIN: 'documentCollections:icon.pin',
  FLAG: 'documentCollections:icon.flag',
  CALENDAR: 'documentCollections:icon.calendar',
  CLOCK: 'documentCollections:icon.clock',
  CHART: 'documentCollections:icon.chart',
  BAR_CHART: 'documentCollections:icon.barChart',
  PIE_CHART: 'documentCollections:icon.pieChart',
  TREND_UP: 'documentCollections:icon.trend',
  CAMERA: 'documentCollections:icon.camera',
  IMAGE: 'documentCollections:icon.image',
  MUSIC: 'documentCollections:icon.music',
  VIDEO: 'documentCollections:icon.video',
  LINK: 'documentCollections:icon.link',
  GLOBE: 'documentCollections:icon.globe',
  MAP: 'documentCollections:icon.map',
  CART: 'documentCollections:icon.cart',
  GIFT: 'documentCollections:icon.gift',
  BRIEFCASE: 'documentCollections:icon.briefcase',
  LIGHTBULB: 'documentCollections:icon.idea',
  ROCKET: 'documentCollections:icon.rocket',
  USERS: 'documentCollections:icon.users',
  USER: 'documentCollections:icon.user',
  BUILDING: 'documentCollections:icon.building',
  CONTACT: 'documentCollections:icon.contact',
  HANDSHAKE: 'documentCollections:icon.handshake',
  KANBAN: 'documentCollections:icon.kanban',
  LIST_CHECKS: 'documentCollections:icon.checklist',
  PACKAGE: 'documentCollections:icon.package',
  BOX: 'documentCollections:icon.box',
  RECEIPT: 'documentCollections:icon.receipt',
  WALLET: 'documentCollections:icon.wallet',
  BANKNOTE: 'documentCollections:icon.banknote',
  CREDIT_CARD: 'documentCollections:icon.creditCard',
  DOLLAR_SIGN: 'documentCollections:icon.dollar',
  STORE: 'documentCollections:icon.store',
  WAREHOUSE: 'documentCollections:icon.warehouse',
  TRUCK: 'documentCollections:icon.truck',
  WRENCH: 'documentCollections:icon.wrench',
  SETTINGS: 'documentCollections:icon.settings',
  SHIELD: 'documentCollections:icon.shield',
  LOCK: 'documentCollections:icon.lock',
  KEY: 'documentCollections:icon.key',
  MAIL: 'documentCollections:icon.mail',
  PHONE: 'documentCollections:icon.phone',
  MESSAGE: 'documentCollections:icon.message',
  HEADPHONES: 'documentCollections:icon.headphones',
  CODE: 'documentCollections:icon.code',
  DATABASE: 'documentCollections:icon.database',
  SERVER: 'documentCollections:icon.server',
  CLOUD: 'documentCollections:icon.cloud',
  ZAP: 'documentCollections:icon.zap',
  TARGET: 'documentCollections:icon.target',
  TROPHY: 'documentCollections:icon.trophy',
}
